<template>
      <div class="panel thread" v-if="posts">
        <breadcrumbs 
        :breadcrumbs="[
        {title: 'Forum', link: '/forum'}, 
        {title: forum, link: '/discussion/' + forumId},
        {title: topic, link: '/discussion/' + forumId + '/' + topicId},

        ]">
        </breadcrumbs>

        <div class="panel-heading"><h2>{{topic}}</h2></div>
          <div class="panel-body">     
            <div class="clearfix">   

                <div  v-for="(post, $index) in posts">
                     <discussion-post 
                        v-if="post.topLevel === true"                    
                         :answerData="answer" 
                         :threadCreator="createdBy" 
                         :postData="post" 
                         :topic="topicId" 
                         :title="topic" 
                         :tags="tags"
                         :postCategories="categories">                     
                     </discussion-post>
                      <discussion-post 
                        v-else                                             
                         :threadCreator="createdBy" 
                         :postData="post" 
                         :topic="topicId" 
                         :title="topic"                          
                         >                     
                     </discussion-post>
                </div>              
            </div>
            <ul class="forum-pagination" v-if="totalPages > 1">
                <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage - 1)">&laquo;</a></li>
             
                <li v-for="i in totalPages">
                    <a href="#"  
                    @click.prevent="currentPage = (i - 1)"
                    :class="{'current-page': i === (currentPage+1)}">
                        {{i}}
                    </a>
                </li>

                <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage + 1)">&raquo;</a></li>

            </ul>

            <form class="col-xs-12" @submit.prevent="postReply(topicId)">
<!--                 <div class="form-group" id="found-users">
                    <select v-if="foundUsers" @change="tagUser($event)" class="form-control">
                        <option value="" default disabled selected>Tag User</option>
                        <option v-for="user in foundUsers"  :value="user.id">{{user.firstName}} {{user.lastName}}</option>
                    </select>
                </div> -->
                <div class="form-group" id="post-reply">
                    <vue-html5-editor @change="updateContent" ref="replyForm" :content="reply" :height="300"></vue-html5-editor>
                </div>
                <div class="form-group">
                    <input type="submit" class="btn btn-success" value="Submit">
                </div>
            </form>

        </div>
        <div @keyup="closeLightbox()" class="lightbox" v-if="lightboxImages"><i class="fa fa-remove"  @click="lightboxImages=null"></i>
          <swiper :options="swiperOption" ref="lightbox">
            <swiper-slide @click="lightboxImages=null" v-for="slide in lightboxImages">
                <img :src="slide">
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          </swiper>
        </div>


<!--         <div @click="lightboxImages=null" class="lightbox" v-if="lightboxImages">
            <i class="fa fa-remove"></i>
            <ul class="post-images" @click="lightboxImages=null">
                <li v-for="(url,index) in lightboxImages" @click="lightboxImages=null">
                    <img @click.stop :src="url">
                </li>
            </ul>
        </div> -->
    </div>
    

</template>


<script>

    import router from '../router';

    import users from '../services/users';
    import discussions from '../services/discussions';
    import discussionPost from './reusable/discussion/DiscussionPost';
    import breadcrumbs from './widgets/ForumBreadcrumbs.vue';
    import toastr from 'toastr';
    import VueScrollTo from 'vue-scrollto';
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        data() {
            return {
                categories: null,
                tags:null,
                answer: null,
                topicId: null,
                forumId: null,
                forum: null,
                topic: null,
                posts: null,
                totalPages: null,
                title: null,
                lightboxImages: null,
                lightboxIndex: 0,
                currentPage: 0,
                reply:'',
                users: [],
                tag: '',
                taggedUsers: [],
                initialLoad: true,
                swiperOption: {
                    keyboard: {
                        enabled: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
            }
        },
        components: {
            'discussion-post': discussionPost,
            breadcrumbs,
            swiper,
            swiperSlide
        },
        mounted() {
            var self = this;
            this.topicId = this.$route.params.topicId;               
            this.forumId = this.$route.params.forumId;
            this.getUsers();           

            self.getPosts().then(function(done) {
                self.initialLoad = false;
            });

            self.$bus.$on('postAdded', function() {
                self.getPosts(); 
            });

            self.$bus.$on('open_lightbox', function(urls, clicked) {
                self.lightboxImages = urls;            
                let index = urls.findIndex(function(u) { return u === clicked});
                self.$nextTick(function(){
                    self.$refs.lightbox.swiper.slideTo(index,0, false);
                });
            });

            $(window).keyup(function(e) {
                if (e.keyCode === 27) {
                    self.lightboxImages = null;
                }
            });

            $('body').on('click', '.swiper-slide', function(e) {
                if ($(e.target).hasClass('swiper-slide')) self.lightboxImages = null;
            });

            self.$bus.$on('reply_to_post', function(body, firstName, lastName) {
                self.prefillReply(body, firstName, lastName);
            });

            self.$bus.$on('type_tag', function(key) {
                self.tag += key
            });

            self.$bus.$on('title_changed', function(title) {
                self.topic = title;
            });

         },
        methods: {
       
            getUsers() {
                var self = this;
                users.getAll(this).then(function(response) {
                    self.users = response.data;                    
                });
            },
            setPage(page) {
                if (page < 0 || page >= this.totalPages) return;
                this.currentPage = page;
            },
            tagUser(event) {
                var self = this;
                let index = self.users.findIndex(function(u) { return u.id == event.target.value});
                let user = self.users[index];
                let url = window.baseUrl + '/#/forum/user?userId=' + event.target.value;
                self.reply = self.reply.replace(self.tag, '<a href="' + url + '">@' + user.firstName + ' ' + user.lastName + '</a>');
                self.taggedUsers.push(user);
                self.tag = ''
            },
            updateContent(content) {
                var self = this;
                // var atSomeone = /\B\@\w+/g;
                // var match = atSomeone.exec(content);

                // if (match) {
                //     match = match['0'];
                //     self.tag = match;
                //     match = match.replace(/@/,'');
                //     self.foundUsers = self.users.filter(function(u) {
                //         return u.firstName.toLowerCase().startsWith(match.toLowerCase())
                //     });
                // }
                this.reply = content;
            },
            prefillReply(body, firstName, lastName) {
                var self = this;
                if (self.$refs.replyForm)  {
                    VueScrollTo.scrollTo('#post-reply');
                    self.reply = '<p style="font-style:italic">' + firstName + ' ' + lastName + ': </p><blockquote>' + body + '</blockquote></p>';
                    self.$nextTick(function() {
                        $('.vue-html5-editor').children('.content').children('blockquote').next('p').html('<br>');                    
                    });
                        
                }

            },
            postReply() {
                var self = this;
              
                if (!self.reply) {
                    toastr.error('Please enter a post');
                    return;
                }
                let body = self.reply.replace(/ttto-discussion-images-full/g, 'ttto-discussion-images');

                var reply = {
                    forumId: this.forumId,
                    topicId: this.topicId,
                    body: body                  
                }

                discussions.reply(this, reply).then(function(response) {
                    self.reply = '';
                    self.currentPage = self.totalPages - 1;
                    self.getPosts();
                    
                });
            },

            getPosts: function(userId) {

                var self = this;
                var thread = {};
                self.posts = null;
                return new Promise(function(resolve, reject) {

                if (self.$store.getters.loading === false) {
                    self.$store.dispatch('toggle',{type:'loading', boolean: true});
                }

                discussions.getPosts(self, self.topicId, self.currentPage).then(function(response) {
                        self.posts = response.data.posts;
                        self.forum = response.data.forum;
                        self.topic = response.data.topic;  
                        self.createdBy = response.data.createdBy;
                        self.categories = response.data.categories.map(function(c) { return {name:c.name, id: c.id, type: c.type}});
                        self.tags = response.data.tags.map(function(t) { return {name:t.name, id: t.id}});
                        self.answer = response.data.answer;
                        self.totalPages  = Math.ceil(response.data.count / 10);
                    
                        if (self.initialLoad === true && self.totalPages > 1) {
                            self.currentPage = self.totalPages - 1;
                            resolve();
                            self.getPosts();

                        }  else {

                        self.$store.dispatch('toggle',{type:'loading', boolean: false});
      
                        discussions.getParent(self, self.topicId).then(function(res) {
                                if (res.data.creator == localStorage.user_id) {
                                    let postIds = self.posts.map(function(p) { return p.id});
                                    discussions.markAsRead(self, postIds);
                                    self.$bus.$emit('reload');
                                }
                            }); 
                        }

                    });
                });
            }
        },
        watch: {

            '$route.params.forumId':function() {
                this.forumId = this.$route.params.forumId;
                this.currentPage = 0;
                this.getPosts()
            },

            '$route.params.topicId': function() {
                this.topicId = this.$route.params.topicId;
                this.currentPage = 0;
                this.getPosts()
            },

            currentPage(page) {
                if ( (page < 0) || (page >= this.totalPages)) {
                    return;
                } else {
                    this.getPosts();
                }
            }
       },
       computed: {
           foundUsers() {
            if (this.tag === '') return;
            let tag = this.tag.replace('@','');
            return this.users.filter(function(u) {
                return u.firstName.toLowerCase().startsWith(tag.toLowerCase());
            })
           }
       }
    }

</script>
<style lang="scss">

    blockquote {
        padding: 10.5px 21px;
        margin: 0 0 21px;
        font-size: 14px!important;
        border-left: 5px solid #464545;
        background: rgba(0,0,0,.2);
        color: #ccc;
        box-shadow: 3px 2px 5px rgba(0,0,0,.1);
    }

    .swiper-container {
        text-align:center;
    }

</style>
<style lang="scss" scoped>

.forum-pagination {
    //margin:2rem 0;
    //max-width: 70%;
    margin-top:2rem;
    margin-bottom:2rem;
}

.post-images {
    display:flex;

    li {
        text-align:center;
        width:100vw;
    }
}

//#found-users {
//     position:absolute;
//     background:#444;
//     z-index:999999;
// }
</style>


// WEBPACK FOOTER //
// Thread.vue?6a9cc34c